/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingHolderDetailConfig } from '../../config/loading.config';
import { notificationHoldersConfig } from '@/pages/HolderPage/config/notifications.config';
import { updateKYCHolderDetailConfig } from '../../config/updateKyc.config';
import { appHeaderHolderDetailConfig } from '../../config/appHeader.config';
import { headerHolderDetailConfig } from '../../config/header.config';
export interface IstaticHolderDetailPluginMethods extends IPluginMethodMap {
  getstaticHolderDetailSync(args?: any): any;
}

export class staticHolderDetailPlugin implements IAgentPlugin {
  readonly methods: IstaticHolderDetailPluginMethods;

  constructor() {
    this.methods = {
      getstaticHolderDetailSync: this.getstaticHolderDetailSync.bind(this),
    };
  }

  getstaticHolderDetailSync(args?: any) {
    return {
      loading: loadingHolderDetailConfig,
      notification: notificationHoldersConfig,
      kycForm: updateKYCHolderDetailConfig,
      appHeader: appHeaderHolderDetailConfig,
      header: headerHolderDetailConfig,
    };
  }
}
